import * as React from 'react';

import { CourseWrapper } from 'common/entities/courseWrapper/CourseWrapper';
import { FlexJustify } from 'common/fragments/Flex';
import Loading from 'common/fragments/Loading';
import NonIdealState from 'common/fragments/NonIdealState';
import { BlockVariant, BlockView } from 'common/views/block/BlockView.view';
import { ButtonVariant, ButtonView } from 'common/views/button/Button.view';
import { DropdownSelectVariant } from 'common/views/dropdownSelect/DropdownSelect.view';
import { OptionDropdownSelect } from 'common/views/dropdownSelect/OptionDropdownSelect';
import { RowsView } from 'common/views/rows/Rows.view';
import { Query } from 'core/api/typedQuery';
import Label from 'core/components/label/Label';
import { IPanelProps, Panel } from 'core/decorators/Panel';
import { isEmpty } from 'core/util/ArrayUtils';
import { validateList } from 'core/util/ParamUtil';
import StringUtil from 'core/util/StringUtil';
import { iDef } from 'core/util/TypeUtils';
import { PARAM_ENTRIES_PAGE_SIZE, PARAM_ENTRIES_QUERY, PARAM_ENTRIES_SORT, PARAM_TAGS } from './BundleEntries.panel';
import { CourseComponent } from './component/CourseComponent';
import Entry from './entities/Entry';
import { EntriesConfig } from './EntriesConfig';

/**
 * @description panel for rendering lists of available courses (not bundle filtered)
 * @author chills
 */

const sortOptions = [
	{value: 'entry.startDate', label: "Recently Released"},
	{value: 'entry.displayName', label: "Name"}
];

interface IEntriesParams {
	sort?: string;
	pageSize?: number;
}

const EntriesQuery = Query.queryMany<Entry, IEntriesParams>(Entry);

@Panel({id: "entries", configClass: EntriesConfig, pageParams: true})
export class EntriesPanel extends React.PureComponent<IPanelProps<EntriesConfig>> {

	public render() {
		const { config, pageParams } = this.props;

		const defaultPageSize: number = iDef(config.pageSize) ? config.pageSize : 4;
		const currentPageSize: number = StringUtil.toInteger(pageParams[PARAM_ENTRIES_PAGE_SIZE], defaultPageSize);

		const params = config.enableRefine ? {
			pageSize: currentPageSize,
			sort: validateList(['entry.startDate', 'entry.displayName'], pageParams[PARAM_ENTRIES_SORT], null),
			query: pageParams[PARAM_ENTRIES_QUERY] || null,
			tags: pageParams[PARAM_TAGS] || null
		} : {};

		return [
			config.enableRefine && (
				<BlockView key="refine" variant={BlockVariant.REFINE} viewKey="refine">
					<FlexJustify>
						<div>
							search is here
						</div>
						<div>
							<OptionDropdownSelect
								onChange={this.onChangeParam(PARAM_ENTRIES_SORT)}
								options={sortOptions}
								value={pageParams[PARAM_ENTRIES_SORT]}
								variant={DropdownSelectVariant.MINIMAL}
								viewKey="refine.sort"
							>
								<Label k="refine.sort" v="Sort" />
							</OptionDropdownSelect>
						</div>
					</FlexJustify>
				</BlockView>
			),
			<EntriesQuery key="query" params={params}>
				{
					({data, loading}) => {
						if (loading) {
							return <Loading key="loading" />;
						}

						if (isEmpty(data)) {
							return (
								<NonIdealState
									key="empty"
									title={<Label k="entries.empty.title" v="No Courses Found" />}
									description={<Label k="entries.empty.description" v="Try different search parameters." />}
								/>
							);
						}

						return (
							<div key="data">
								<RowsView viewKey="rows">
									{data.map(this.renderEntry)}
								</RowsView>
								{
									config.enableLoadMore && data.length >= currentPageSize && (
										<BlockView variant={BlockVariant.PAGING} viewKey="paging">
											<ButtonView
												onClick={() => this.onChangeParam(PARAM_ENTRIES_PAGE_SIZE)(currentPageSize + defaultPageSize)}
												variant={ButtonVariant.PRIMARY}
												viewKey="load-more"
											>
												<Label k="messages.loadmore" v="Load More" />
											</ButtonView>
										</BlockView>
									)
								}
							</div>
						);
					}
				}
			</EntriesQuery>
		];
	}

	private renderEntry = (entry: Entry) => {
		const w = CourseWrapper.forEntry(entry);

		if (!w) {
			return null;
		}

		return <CourseComponent key={entry.id} course={w} config={this.props.config.courseConfig}
			enableBundlePurchase={false} />;
	}

	private onChangeParam = (name: string) => (value: any) => {
		if (iDef(value)) {
			this.props.actions.pushPageParam(name, value);
		} else {
			this.props.actions.removePageParam(name);
		}
	}
}



// WEBPACK FOOTER //
// ./src/panels/bundleEntries/Entries.panel.tsx